'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var WhatIfService = function WhatIfService($q, liteDataService, momentService, userSecureService, serializeRuleService, RuleListingTransformerFactory) {
  var transformer = new RuleListingTransformerFactory();
  var SORTING_ORDER = {
    MARKET_DEMAND: ['departureDate', 'pos', 'market'],
    SERVICE: ['departureDate', 'pos', 'routeId'],
    FLIGHT: ['departureDate', 'flightNumber', 'leg']
  };
  function triggerWhatIf(carrier, startDate, endDate, technicalId) {
    var request = {
      carrier: carrier,
      technicalId: technicalId,
      startDate: momentService.copy(startDate, momentService.FIELD.RULE_CRITERIA_DATE).toISOString(),
      endDate: momentService.copy(endDate, momentService.FIELD.RULE_CRITERIA_DATE).toISOString()
    };
    return liteDataService.post('rules/whatif', {
      queueElements: [request]
    }).then(function (res) {
      if (_.isArray(res) && res.length > 0) {
        toastr.success('What-if request submitted');
        return res;
      } else {
        toastr.error('What-if request for a different rule is currently in progress');
        return $q.reject();
      }
    })["catch"](function () {
      toastr.error('What-if request failed');
    });
  }
  function prepareWhatIfStatus(response) {
    if (!response.whatIfId) {
      return {
        globalStatus: response.globalStatus
      };
    }
    return {
      whatIfId: response.whatIfId,
      status: response.status,
      globalStatus: response.globalStatus,
      startDate: momentService.of(response.startDate, momentService.FIELD.RULE_CRITERIA_DATE),
      endDate: momentService.of(response.endDate, momentService.FIELD.RULE_CRITERIA_DATE)
    };
  }
  function getWhatIfStatus(rule) {
    var request = {
      technicalId: rule.technicalId,
      userId: userSecureService.getUserId()
    };
    return liteDataService.get('rules/whatif/status?noSpinner=true', request).then(function (response) {
      return response.whatIfId || response.globalStatus ? prepareWhatIfStatus(response) : false;
    })["catch"](function (e) {
      toastr.error('Error retrieving what-if request status', e);
      return false;
    });
  }
  function transformWhatIfRecord(record, rules) {
    var ruleIds = _.map(rules, 'technicalId');
    return record.results.map(function (result) {
      var filteredRules = _.filter(result.appliedRules, function (id) {
        return _.includes(ruleIds, id);
      });
      result.appliedRulesData = _.map(filteredRules, function (id) {
        return {
          id: id,
          isWhatIfRule: id === record.ruleTechnicalId,
          isConflict: _.includes(result.conflicts, id)
        };
      });
      result.ruleApplies = _.includes(result.appliedRules, record.ruleTechnicalId) ? 'APPLIED' : '';
      result.ruleApplies += _.some(result.appliedRulesData, 'isConflict') ? 'CONFLICT' : '';
      result.departureDate = momentService.of(record.departureDate, momentService.FIELD.DEPARTURE_DATE);
      return result;
    });
  }
  function transformResults(results, rules) {
    var groupedResults = _.chain(results).map(function (results) {
      return transformWhatIfRecord(results, rules);
    }).flatten().groupBy('entityType').value();
    _.forOwn(groupedResults, function (group, type) {
      if (SORTING_ORDER[type]) {
        groupedResults[type] = _.sortBy(group, SORTING_ORDER[type]);
      }
    });
    return groupedResults;
  }
  function getWhatIfResults(whatIfStatus) {
    var request = {
      pageLimit: 1000,
      filter: 'whatIfId=="' + whatIfStatus.whatIfId + '"',
      sortBy: 'departureDate',
      sortOrder: 'ASC'
    };
    return liteDataService.get('domain/whatIfResults', request).then(function (res) {
      var results = res.results;
      var ruleIds = _.chain(results).map('results').flatten().map('appliedRules').flatten().uniq().value();
      if (ruleIds.length > 0) {
        var request = {
          pageLimit: 1000,
          filter: 'technicalId=in=(' + _.join(ruleIds) + ')'
        };
        return liteDataService.get('rules', request).then(function (res) {
          var rules = transformer.transform({
            domain: {
              detailedRules: res.detailedRules
            }
          }).map(serializeRuleService.parseRule);
          return {
            results: transformResults(results, rules),
            rules: _.keyBy(rules, 'technicalId')
          };
        })["catch"](function () {
          toastr.error('Rules request failed');
        });
      } else {
        return {
          results: transformResults(results, []),
          rules: {}
        };
      }
    })["catch"](function () {
      toastr.error('What-if request failed');
    });
  }
  return {
    triggerWhatIf: triggerWhatIf,
    getWhatIfResults: getWhatIfResults,
    getWhatIfStatus: getWhatIfStatus
  };
};
WhatIfService.$inject = ['$q', 'LiteDataService', 'MomentService', 'UserSecureService', 'SerializeRuleService', 'RuleListingTransformerFactory'];
module.exports = WhatIfService;